import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { COUNTRY_INFO } from '../../constans/countries/countries'
import { VisitedListContainer } from './VisitedListContainer/VisitedListContainer'
import styles from './styles.module.css'

export const VisitedListComponent = ({ visitedCountries, isShared = false }) => {

    const visitedListState = useSelector((state) => state.visitedList.visited);
    const visitedListAllowed = visitedCountries || visitedListState;
    const sortedVisitedList = [...visitedListAllowed].reverse();
    const [showDelete, setShowDelete] = useState('hideDeleteButton');
    const [buttonText, setButtonText] = useState('Edit');
    const [showAll, setShowAll] = useState(false);

    const editButtonFunction = () => {
        setShowDelete(showDelete === 'hideDeleteButton' ? 'showDeleteButton' : 'hideDeleteButton');
        setButtonText(showDelete === 'hideDeleteButton' ? 'Done' : 'Edit')
    }

    const countriesToShow = showAll ?
                            sortedVisitedList :
                            sortedVisitedList.slice(0,7)

  return (
    <div className={styles.root}>
    {(visitedListState.length && !isShared &&
        (<button
                className={styles.edit_button}
                onClick={() => editButtonFunction()}>
                {buttonText}
        </button>
        )) || null }
      <div className={styles.content_wrapper}>
        {countriesToShow.map(e => 
            <VisitedListContainer 
                country={COUNTRY_INFO[e]} 
                makeVisibleStyle={showDelete}
            />)}
      </div>
      {visitedListState.length > 7 && (
          <div className={styles.others_button_container}>
          {!showAll ? 
            <button
              className={styles.others_button}
              onClick={() => setShowAll(!showAll)}>
              See others
              <div className={styles.others_arrow_icon}>→</div>
            </button>
            :
            <button
              className={styles.others_button}
              onClick={() => setShowAll(!showAll)}>
              <div className={styles.others_arrow_icon}>←</div>
              Show less
            </button>
          }
          </div>
      )}
     </div>
  )
}
